import { render, staticRenderFns } from "./BildschirmPlaner.vue?vue&type=template&id=56ef64e4&"
import script from "./BildschirmPlaner.vue?vue&type=script&lang=js&"
export * from "./BildschirmPlaner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports